enum UserAgent {
    Research = 'blockworks-research/1.0',
    Studio = 'blockworks-studio/1.0',
    Editorial = 'blockworks-editorial/1.0',
}

export { UserAgent };
